import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import TEAM_MEMBERS from '../teamMembers.config';
import { TextOnlyTeamMember } from '../teamMembers.types';
import { getTypeStyle } from '../teamTypeStyles';
import { TeamType } from '../teamTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextOnlyTeam',
  setup(__props) {

const textOnlyTeamMembers = computed(() => TEAM_MEMBERS.filter((e): e is TextOnlyTeamMember => e.kind === 'textonly'));

function getTypeColor(type: TeamType): string {
  return getTypeStyle(type).color;
}

const cards = computed(() => {
  const teamMembers = textOnlyTeamMembers.value;
  const result: TextOnlyTeamMember[][] = [];

  for (let i = 0; i < teamMembers.length; i += 5) {
    result.push(teamMembers.slice(i, i + 5));
  }

  return result;
});

const containerClass = computed(() => {
  const cardCount = cards.value.length;
  if (cardCount === 1) return 'c-single-card';
  if (cardCount === 2) return 'c-double-card';
  return '';
});

return { __sfc: true,textOnlyTeamMembers, getTypeColor, cards, containerClass }
}

})